import styled from '@emotion/styled';
import ArticleBody from './InnerHtmlStyling';
import breakpoints from './Theme/breakpoints';

export default styled(ArticleBody)`
  /* stylelint-disable-next-line selector-type-no-unknown */
  progressive-img[src$='MDAuanBn'] {
    /* override inline image style */
    /* stylelint-disable-next-line declaration-no-important */
    width: 100px !important;
    float: left;
    margin-right: 25px;
  }
  /* stylelint-disable-next-line selector-type-no-unknown */
  progressive-img[src$='DEwMC5qcGc'] {
    /* override inline image style */
    /* stylelint-disable-next-line declaration-no-important */
    width: 100px !important;
    float: left;
    margin-right: 25px;
  }

  #introduction_else .thumbnail {
    padding: 0;
    border: none;
  }
`;

export const StyledGrid = styled.div`
  padding: 16px;
  max-width: 1100px;
  margin: 0 auto;

  @media (min-width: ${breakpoints.md}px) {
    padding: 0 24px;
  }
`;
